import {
    ProfileInfo,
    ProfileInfoCitizenForm,
    ProfileInfoForm,
} from "modules/common/components/ProfileInfo";
import { IProfileUserInformationsProps } from "modules/common/components/ProfileUserInformations/types/IProfileUserInformationsProps";
import { RoleType } from "modules/common";
import { TitleBar } from "modules/common";
import { useContext } from "react";
import { AccessibilityContext } from "views/AccessibilityContext";

export function ProfileUserInformations({ roleType, profile }: IProfileUserInformationsProps) {
    const isCitizen = (roleType: number) => RoleType.Citizen === roleType;
    const isFarmer = (roleType: number | null | undefined) => RoleType.Farmer === roleType;
    const { fontSize } = useContext(AccessibilityContext);

    return (
        <>
            <TitleBar>
                <TitleBar.Left>
                    <span className="title-bar-text profile-title"  style={{ fontSize: `${fontSize}%` }}>Tvoje informacije</span>
                </TitleBar.Left>
                <TitleBar.Right>
                    <span className="title-bar-description" style={{ fontSize: `${fontSize}%` }}>
                        Prikazani podaci su povučeni iz drugog sustava i nije moguća promjena unutar
                        e-Savjetnik sustava.
                    </span>
                </TitleBar.Right>
            </TitleBar>
            <span className="profile-description">Osnovne informacije o korisniku.</span>
            {isCitizen(roleType ?? RoleType.Citizen) ? (
                <>
                    <ProfileInfo className="mt-48">
                        <span className="profile-settings-label">Ime i prezime</span>
                        <span className="profile-settings-text">
                            {profile?.firstName} {profile?.lastName}
                        </span>
                        <span className="profile-settings-label">Uloga</span>
                        <span className="profile-settings-text">
                            {profile?.roleType?.label ?? ""}
                        </span>
                        <span className="profile-settings-label">E-mail</span>
                        <span className="profile-settings-text">{profile?.email}</span>
                        <span className="profile-settings-label">Mjesto</span>
                        <span className="profile-settings-text">{profile?.settlement}</span>
                        <span className="profile-settings-label">Poštanski broj</span>
                        <span className="profile-settings-text">
                            {profile?.postalNumber &&
                                profile.postalNumber.length &&
                                `${profile.postalNumber}`}
                        </span>
                        <span className="profile-settings-label">Adresa</span>
                        <span className="profile-settings-text">
                            {profile?.street} {profile?.streetNumber}
                        </span>
                        <span className="profile-settings-label">Županija</span>
                        <span className="profile-settings-text">{profile?.county}</span>
                    </ProfileInfo>
                    <div className="section-separator" />
                    <ProfileInfoCitizenForm />
                </>
            ) : (
                <>
                    <section>
                        <ProfileInfo>
                            <span className="profile-settings-label">Ime i prezime</span>
                            <span className="profile-settings-text">
                                {profile?.firstName} {profile?.lastName}
                            </span>
                            {isFarmer(roleType ?? RoleType.Farmer) ? (
                                <>
                                    <span className="profile-settings-label">MIBPG</span>
                                    <span className="profile-settings-text">{profile?.mibpg}</span>
                                </>
                            ) : null}
                            {profile?.legalEntityName ? (
                                <>
                                    <span className="profile-settings-label">Poslovni subjekt</span>
                                    <span className="profile-settings-text">
                                        {profile?.legalEntityName}
                                    </span>
                                </>
                            ) : null}
                            <span className="profile-settings-label">Uloga</span>
                            <span className="profile-settings-text">
                                {profile?.roleType?.label ?? ""}
                            </span>
                            <span className="profile-settings-label">E-mail</span>
                            <span className="profile-settings-text">{profile?.email}</span>
                            <span className="profile-settings-label">Mjesto</span>
                            <span className="profile-settings-text">{profile?.settlement}</span>
                            <span className="profile-settings-label">Poštanski broj</span>
                            <span className="profile-settings-text">
                                {profile?.postalNumber &&
                                    profile.postalNumber.length &&
                                    `${profile.postalNumber}`}
                            </span>
                            <span className="profile-settings-label">Adresa</span>
                            <span className="profile-settings-text">
                                {profile?.street} {profile?.streetNumber}
                            </span>
                            <span className="profile-settings-label">Županija</span>
                            <span className="profile-settings-text">{profile?.county}</span>
                        </ProfileInfo>
                    </section>
                    <div className="section-separator" />
                    <ProfileInfoForm />
                </>
            )}
        </>
    );
}
